import {DEFAULT_PREFERRED_INSTITUTE_COOKIE, getPreferredInstituteNumber} from 'app/components/instituteSelection/instituteCookies';
import {type Undef} from 'app/interface';
import {getPreferredInstituteConfig} from 'app/utils/config/getPreferredInstituteConfig';
import {type GemSettings} from 'app/utils/config/interface';
import {type InstituteConfig} from 'interfaces/ebspk/institutes/instituteConfig';

export function getPreferredInstituteConfigFromCookie(gemSettings: GemSettings): Undef<InstituteConfig> {
    const preferredInstituteNumber = getPreferredInstituteNumber();
    let instituteConfig = getPreferredInstituteConfig(preferredInstituteNumber, gemSettings);

    instituteConfig ??= getPreferredInstituteConfig(DEFAULT_PREFERRED_INSTITUTE_COOKIE, gemSettings);
    if (instituteConfig) {
        return instituteConfig;
    }
}
